import React from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import clinicService from "../../../../../services/clinic.service";
import { toast } from 'react-toastify';

function DayForm({ dayData, hof, handleEdit, updateHours }) {
    const { clinicId } = useParams();
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm({
        defaultValues: {
            day: dayData.day,
            start: dayData.start,
            end: dayData.end,
            note: dayData.note,
            status: dayData.status.toString(),
            id: dayData.id,
            clinicId: dayData.clinicId,
        },
    });

    const onSubmit = async (data) => {
        try {
            const newData = hof.map((item) => {
                if (item.id === data.id) {
                    return {
                        ...data,
                        status: data.status === "true"
                    };
                } else {
                    return item;
                }
            });

            const response = await clinicService.updateHours(clinicId, newData);
            updateHours(response.data);

            toast.success("Hours updated successfully!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            handleEdit();
        } catch (err) {
            toast.error("Error updating hours. Please try again.", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="row g-2 align-items-center p-3 bg-light rounded border">
            <div className="col-lg-2 col-md-2">
                <select
                    className={`form-select form-select-sm ${errors.day ? 'is-invalid' : ''}`}
                    {...register("day", { required: "Day is required" })}
                >
                    <option value="MONDAY">Monday</option>
                    <option value="TUESDAY">Tuesday</option>
                    <option value="WEDNESDAY">Wednesday</option>
                    <option value="THURSDAY">Thursday</option>
                    <option value="FRIDAY">Friday</option>
                    <option value="SATURDAY">Saturday</option>
                    <option value="SUNDAY">Sunday</option>
                </select>
                {errors.day && (
                    <div className="invalid-feedback">{errors.day.message}</div>
                )}
            </div>

            <div className="col-lg-3 col-md-3">
                <div className="input-group input-group-sm">
                    <input
                        type="text"
                        className={`form-control ${errors.start ? 'is-invalid' : ''}`}
                        placeholder="Start (e.g., 08:00 AM)"
                        {...register("start", {
                            required: "Start time is required",
                            validate: (value, formValues) => {
                                if (formValues.status === "true" && !value) {
                                    return "Start time is required when open";
                                }
                                return true;
                            }
                        })}
                    />
                    <span className="input-group-text">to</span>
                    <input
                        type="text"
                        className={`form-control ${errors.end ? 'is-invalid' : ''}`}
                        placeholder="End (e.g., 05:00 PM)"
                        {...register("end", {
                            required: "End time is required",
                            validate: (value, formValues) => {
                                if (formValues.status === "true" && !value) {
                                    return "End time is required when open";
                                }
                                return true;
                            }
                        })}
                    />
                </div>
                {(errors.start || errors.end) && (
                    <div className="text-danger small mt-1">
                        {errors.start?.message || errors.end?.message}
                    </div>
                )}
            </div>

            <div className="col-lg-2 col-md-2">
                <select
                    className="form-select form-select-sm"
                    {...register("status")}
                >
                    <option value="true">Open</option>
                    <option value="false">Closed</option>
                </select>
            </div>

            <div className="col-lg-3 col-md-3">
                <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Add note (optional)"
                    {...register("note")}
                />
            </div>

            <div className="col-lg-2 col-md-2">
                <div className="d-flex justify-content-end">
                    <button
                        className="btn btn-sm btn-success me-2 d-flex align-items-center"
                        type="submit"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                Saving...
                            </>
                        ) : (
                            <>
                                <i className="bi bi-check-lg me-1"></i> Save
                            </>
                        )}
                    </button>
                    <button
                        className="btn btn-sm btn-outline-secondary d-flex align-items-center"
                        type="button"
                        onClick={handleEdit}
                        disabled={isSubmitting}
                    >
                        <i className="bi bi-x me-1"></i> Cancel
                    </button>
                </div>
            </div>
        </form>
    );
}

export default DayForm;